// extracted by mini-css-extract-plugin
module.exports = {"list":"_02712f2b3b--list--a5kLH","list-item":"_02712f2b3b--list-item--u2YSa"};